import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NGXLogger } from 'ngx-logger';
import { CustomerAccess, Login, SharedDataService, Staff, User } from 'orv-ui-base-lib';

import { environment } from '../../../../environments/environment';
import { AclService } from '../../data/acl.service';
import { AuthService } from '../auth.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

	logindata: Login = new Login();
	message: string;
	loggedUser: Staff;
	commercial: boolean;

	urls: any[];
	mainpaths: string[];

	constructor(private logger: NGXLogger, private authService: AuthService,
		private sharedDataService: SharedDataService,
		private translateService: TranslateService,
		private aclService: AclService,
		private router: Router) {
		this.sharedDataService.currentLoggedUser.subscribe(u => {
			this.loggedUser = u;
			if (u) {
				this.mainpaths = this.router.config[0].children.map(e => '/' + e.path);
				this.router.navigateByUrl('/');
			}
		});
	}

	ngOnInit() {
		this.commercial = environment.commercial;

	}

	signUp() {
		window.location.href = 'https://onroutevisibility.com';
	}

	login() {
		const messages = {
			failed: this.translateService.instant('labels.login-failed'),
			nofeatures: this.translateService.instant('labels.login-nofeatures')
		};

		this.authService.loginV2(this.logindata).subscribe((data: Staff | CustomerAccess) => {
			if (data) {
				if ((data as User).resetpwd === 1) {
					this.router.navigateByUrl('/resetpwd');
				} else {
					this.sharedDataService.currentFeatures.subscribe((features: string[]) => {
						if (!features.length) {
							this.message = messages.nofeatures;
						}
					});
				}
			} else {
				this.message = messages.failed;
			}
		}, error => {
			this.logger.log('error', error);
			this.message = messages.failed;
		});
	}

}
